import { useState } from "react";
import { advantageItems } from "../../../mocks/technology";

export default function AdvantagesSection() {
  const [expandedId, setExpandedId] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 bg-warm-gray">
      <div className="container-main px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <span className="tag-label mb-3 inline-block">CHRONOS ADVANTAGES</span>
          <h2 className="mb-3">為什麼選擇 Chronos 預製工法？</h2>
          <p className="text-medium-gray max-w-2xl mx-auto">
            不只是蓋得快，而是蓋得更好、更穩、更節能。以下是預製鋼構工法為業主帶來的四大核心價值。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto">
          {advantageItems.map((item, idx) => {
            const isExpanded = expandedId === idx;
            return (
              <div
                key={item.title}
                className={`bg-white rounded-2xl border transition-all duration-300 cursor-pointer overflow-hidden ${
                  isExpanded ? "border-champagne/40 shadow-lg" : "border-warm-gray/20 hover:border-champagne/30 hover:shadow-md"
                }`}
                onClick={() => setExpandedId(isExpanded ? null : idx)}
              >
                {/* Card Header */}
                <div className="p-5 md:p-6 flex items-start gap-4">
                  <span className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 transition-all duration-300 ${
                    isExpanded ? "bg-champagne text-graphite" : "bg-champagne/10 text-champagne"
                  }`}>
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                      <h3 className="text-base font-bold text-graphite">{item.title}</h3>
                      <span className="w-7 h-7 rounded-full bg-champagne/10 flex items-center justify-center shrink-0">
                        <i className={`ri-${isExpanded ? "subtract" : "add"}-line text-champagne text-sm transition-transform duration-300`} />
                      </span>
                    </div>
                    <p className="text-medium-gray text-sm mt-1.5 leading-relaxed">{item.desc}</p>
                  </div>
                </div>

                {/* Expandable Detail */}
                <div className={`overflow-hidden transition-all duration-500 ${
                  isExpanded ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
                }`}>
                  <div className="px-5 pb-5 md:px-6 md:pb-6">
                    <div className="h-px bg-warm-gray/20 mb-4" />
                    <ul className="space-y-2.5">
                      {item.points.map((point) => (
                        <li key={point} className="flex items-start gap-2.5 text-sm text-medium-gray">
                          <span className="w-5 h-5 rounded-full bg-emerald-50 flex items-center justify-center shrink-0 mt-0.5">
                            <i className="ri-check-line text-emerald-600 text-xs" />
                          </span>
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Stat Banner */}
        <div className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {[
            { value: "50%", label: "工期縮短", icon: "ri-time-line" },
            { value: "±2mm", label: "工廠精度", icon: "ri-ruler-line" },
            { value: "40%", label: "碳排降低", icon: "ri-leaf-line" },
            { value: "5°C", label: "室內更涼", icon: "ri-temp-cold-line" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-white rounded-xl border border-warm-gray/20 p-5 text-center hover:border-champagne/30 hover:shadow-md transition-all duration-300"
            >
              <span className="w-10 h-10 rounded-full bg-champagne/10 flex items-center justify-center text-champagne mx-auto mb-3">
                <i className={`${stat.icon} text-lg`} />
              </span>
              <p className="text-2xl md:text-3xl font-serif font-bold text-graphite">{stat.value}</p>
              <p className="text-sm text-medium-gray mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}